import { Component } from '@angular/core';
import { AddProductComponent } from "../../../../components/admin-dashboard-component/add-product-component/add-product-component";

@Component({
  selector: 'app-add-product',
  imports: [AddProductComponent],
  templateUrl: './add-product.html',
  styleUrl: './add-product.scss',
})
export class AddProduct {}
